import { generateBreadcrumbList } from '../../utils/generate-breadcrumb-list';
import { HD_URL_L } from '../../constants';

/**
 * Gets the breadcrumb list for the Store Directory page.
 *
 * @returns {Object} The structured breadcrumb object for the Store Directory page, formatted for JSON-LD.
 */
export const getStoreDirectoryBreadcrumbs = () => {
  return generateBreadcrumbList([
    { name: 'Store Locator', url: 'store-locator' },
    { name: 'Store Directory', url: 'storeDirectory' }
  ], { urlPrefix: HD_URL_L });
};